import AuthenticatedLayout from 'components/layouts/authenticatedLayout';
import NotAuthenticatedLayout from 'components/layouts/notAuthenticatedLayout';
import { Route, Routes } from 'react-router';
import ProtectedRoute from '../components/protectedRoute';
import {
  CONTACTS_URL,
  CONTACT_DETAIL_URL,
  DEVICES_DETAIL_URL,
  DEVICES_URL,
  DOWNLOAD_RECEIPT_OR_INVOICE_DUPLICATE,
  DOWNLOAD_RECEIPT_OR_INVOICE_ERROR,
  DOWNLOAD_RECEIPT_OR_INVOICE_JOURNEY,
  DOWNLOAD_RECEIPT_OR_INVOICE_PAY_WINDOW,
  DOWNLOAD_RECEIPT_OR_INVOICE_SUCCESS,
  FAQ_URL,
  HEALTH_CHECK_URL,
  HELP_URL,
  LOADING_URL,
  LOGIN_URL,
  RIDES_URL,
  ROOT_URL,
} from './appRoutesConst';
import ContactDetail from './contactDetail';
import Contacts from './contacts';
import Dashboard from './dashBoard';
import DeviceDetailPage from './deviceDetailPage';
import DevicesPage from './devicesPage';
import DownloadReceiptOrInvoicePage from './downloadReceiptOrInvoicePage';
import DuplicatePage from './duplicatePage';
import ErrorPage from './errorPage';
import Faq from './faq';
import HealthCheck from './healthCheck';
import HelpPage from './helpPage';
import LoadingPage from './loadingPage';
import Login from './login';
import RidesPage from './ridesPage';
import SuccessPage from './successPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* AUTHENTICATED ROUTES */}
      <Route
        element={
          <ProtectedRoute>
            <AuthenticatedLayout />
          </ProtectedRoute>
        }
      >
        <Route path={ROOT_URL} element={<Dashboard />} />
        <Route path={RIDES_URL} element={<RidesPage />} />
        <Route path={FAQ_URL} element={<Faq />} />
        <Route path={CONTACTS_URL} element={<Contacts />} />
        <Route path={HELP_URL} element={<HelpPage />} />
        <Route path={DEVICES_URL} element={<DevicesPage />} />
        <Route
          path={`${DEVICES_DETAIL_URL}/:id`}
          element={<DeviceDetailPage />}
        />
        <Route
          path={`${CONTACT_DETAIL_URL}/:id`}
          element={<ContactDetail />}
        />
        <Route
          path={`${DOWNLOAD_RECEIPT_OR_INVOICE_PAY_WINDOW}/:payWindowId`}
          element={<DownloadReceiptOrInvoicePage />}
        />
        <Route
          path={`${DOWNLOAD_RECEIPT_OR_INVOICE_JOURNEY}/:journeyId`}
          element={<DownloadReceiptOrInvoicePage />}
        />
        <Route
          path={DOWNLOAD_RECEIPT_OR_INVOICE_SUCCESS}
          element={<SuccessPage />}
        />
        <Route
          path={DOWNLOAD_RECEIPT_OR_INVOICE_DUPLICATE}
          element={<DuplicatePage />}
        />
        <Route
          path={DOWNLOAD_RECEIPT_OR_INVOICE_ERROR}
          element={<ErrorPage />}
        />
      </Route>
      {/* NOT AUTHENTICATED ROUTES */}
      <Route element={<NotAuthenticatedLayout />}>
        <Route path={`${LOGIN_URL}`} element={<Login />} />
      </Route>
      <Route path={`${LOADING_URL}`} element={<LoadingPage />} />
      <Route path={`${HEALTH_CHECK_URL}`} element={<HealthCheck />} />
    </Routes>
  );
};

export default AppRoutes;
